/** UI / providerOptions：是否开启仿真人自动审核（百度 CreateAsset / 腾讯 CreateAigcMaterial） */
export const AIGC_MATERIAL_REVIEW_OPTION = 'aigc_material_review';

/** 用户选项默认开启；显式 false 时跳过提审以节省资源 */
export function isAigcMaterialReviewEnabled(
  providerOptions?: Record<string, any>,
): boolean {
  const value = providerOptions?.[AIGC_MATERIAL_REVIEW_OPTION];
  if (typeof value === 'boolean') return value;
  return true;
}